import React from 'react';
import { Create, SimpleForm, TextInput } from 'react-admin';

export const SignalBotSettingCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="api_key" label="Api key" />
      <TextInput source="version" label="Version" />
    </SimpleForm>
  </Create>
);